export enum ContactType {
  CHAT = 'CHAT',
  EMAIL = 'EMAIL',
  EVENT = 'EVENT',
  FAX = 'FAX',
  PHONE_CALL = 'PHONE_CALL',
  MEETING = 'MEETING',
  LETTER = 'LETTER',
  VIDEO_CONFERENCE = 'VIDEO_CONFERENCE',
  OTHER = 'OTHER',
}

export const ContactTypeOptions = [
  {
    value: ContactType.CHAT,
    label: 'BJB Chat',
  },
  {
    value: ContactType.EMAIL,
    label: 'Email',
  },
  {
    value: ContactType.EVENT,
    label: 'Event',
  },
  {
    value: ContactType.FAX,
    label: 'Fax',
  },
  {
    value: ContactType.MEETING,
    label: 'Meeting/Visit',
  },
  {
    value: ContactType.PHONE_CALL,
    label: 'BJB Phone',
  },
  {
    value: ContactType.LETTER,
    label: 'Letter',
  },
  {
    value: ContactType.VIDEO_CONFERENCE,
    label: 'Video (BJB Webex)',
  },
  {
    value: ContactType.OTHER,
    label: 'Other',
  },
];

const contactTypes = { ContactTypeOptions, ContactTypeEnums: ContactType };
export default contactTypes;
